import React, { useEffect, useRef, useCallback } from "react";
import styles from "./index.module.scss";
import FlipperVaultListItem from "../../../stories/common/flipper-vault-list-item";
import FlipperVaultListSkeleton from "../../../skeleton/flipper-vault-list-skeleton";
import { useFlipperVault } from "../../../hooks/react-query/inv-exchange/useFlipperVault";

export default function ListView() {
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading } =
    useFlipperVault();

  const observerTarget = useRef<HTMLDivElement>(null);

  const handleObserver = useCallback(
    (entries: IntersectionObserverEntry[]) => {
      const [target] = entries;
      if (target.isIntersecting && hasNextPage && !isFetchingNextPage) {
        fetchNextPage();
      }
    },
    [fetchNextPage, hasNextPage, isFetchingNextPage]
  );

  useEffect(() => {
    const element = observerTarget.current;
    if (!element) return;

    const observer = new IntersectionObserver(handleObserver, {
      threshold: 0.1
    });

    observer.observe(element);

    return () => {
      if (element) observer.unobserve(element);
    };
  }, [handleObserver]);

  if (isLoading) {
    return (
      <div className={styles.ListViewWrap}>
        {[1, 2, 3].map((key) => (
          <FlipperVaultListSkeleton key={key} />
        ))}
      </div>
    );
  }

  return (
    <>
      <div className={styles.ListViewWrap}>
        {data?.pages &&
          data?.pages?.map(
            (page:any) =>
              page &&
              page?.items?.map((vault: any) => (
                <FlipperVaultListItem key={vault.id} flipperData={vault} />
              ))
          )}
      </div>

      <div ref={observerTarget}>
        {isFetchingNextPage && (
          <div
            className={`${styles.ListViewWrap} ${styles.ListViewWrapLoader}`}
          >
            {[1, 2, 3].map((key) => (
              <FlipperVaultListSkeleton key={key} />
            ))}
          </div>
        )}
      </div>
    </>
  );
}
